module.exports = __webpack_public_path__ + "img/compras_bronze.025f064c.png";